import { deleteItems } from './deleteItems';
import blockLastSendersHelper from './helpers/blockLastSendersHelper';
import { tryGetMailboxesFromItemIds } from './helpers/getMailboxes';
import { InstrumentationContext } from 'owa-mail-store';
import DisposalType from 'owa-service/lib/contract/DisposalType';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { trace } from 'owa-trace';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';

/**
 * Block the sender smtp addresses from the given item ids
 * @param itemIdToBlock the item id
 */
export default function blockLastSenderFromReadingPane(
    itemId: string,
    instrumentationContexts: InstrumentationContext[],
    actionSource?: ActionSource
) {
    if (!itemId) {
        trace.error('blockLastSendersFromReadingPane should not be called on invalid items.');
        return;
    }

    // De-duped senders
    const mailboxes = tryGetMailboxesFromItemIds([itemId]);
    blockLastSendersHelper(mailboxes, () => {
        deleteItemUponBlock(itemId, instrumentationContexts, actionSource);
    });
}

const deleteItemUponBlock = createLegacyActionWithDatapoint('deleteItemUponBlock', {
    name: 'TnS_BlockSenderFromReadingPane',
    actionSource: (
        itemIdToBlock: string,
        instrumentationContexts: InstrumentationContext[],
        actionSource?: ActionSource
    ) => actionSource,
})(function deleteItemUponBlock(
    itemIdToBlock: string,
    instrumentationContexts: InstrumentationContext[],
    actionSource?: ActionSource
) {
    const disposalType: DisposalType = isConsumer() ? 'HardDelete' : 'MoveToDeletedItems';

    return deleteItems([itemIdToBlock], disposalType, instrumentationContexts);
});
